export default "__VITE_ASSET__DC6yYbZ1__"